export default {
	name: 'Purchases',
	collection: true,
	form: {
		component: 'Purchase',
		api: 'purchase',
		noun: 'purchase'
	},
	meta: {
		isAccount: true
	}
}